<template>
  <div>
    <v-header></v-header>
    <v-banner></v-banner>
    <div class="content">
      <produce-service></produce-service>
      <local-service></local-service>
      <big-data-show></big-data-show>
      <cooperative-partner></cooperative-partner>
      <contactus></contactus>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import header from './components/decorator/header.vue'
  import footer from './components/decorator/footer.vue'
  import banner from './components/banner.vue'
  import produceService from './components/index/productAndServices.vue'
  import localService from './components/index/localService.vue'
  import bigDataShow from './components/index/bigDataShow.vue'
  import cooperativePartner from './components/index/cooperativePartner.vue'
  import contactUs from './components/contactUs.vue'
  import jQuery from './js/jquery-1.11.3.min.js'
  export default {
    name: 'app',
    components: {
      'v-header': header,
      'v-footer': footer,
      'v-banner': banner,
      'produce-service': produceService,
      'local-service': localService,
      'big-data-show': bigDataShow,
      'cooperative-partner': cooperativePartner,
      'contactus':contactUs
    }
  }
  
</script>
<style lang="less" rel="stylesheet/less">
  * {
    padding: 0;
    margin: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Microsoft Yahei";
  }
  html {
    font-size: 62.5%;
  }
  body {
    font-size: 1.6rem;
    font-family: "Microsoft Yahei";
  }
  .content{
    background: #f6f6f6;
    clear:both;
  }
  .common_button,.square_button {
    text-align: center;
    a {
      height: 56px;
      line-height: 56px;
      border: 2px solid #9ac865;
      padding: 15px 70px;
      border-radius: 25px;
      color: #9ac865;
      cursor: pointer;
    }
  }
  .square_button {
    a {
      border-radius:5px;
    }
  }
  .bigTitle {
    font-size: 2.083vw;
    font-weight: 400;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 20px;
    position: relative;
    color: #154e93;
    .border_bottom {
      position: absolute;
      bottom:0;
      display: inline-block;
      height: 4px;
      width: 9.9vw;
      left: 50%;
      margin-left: -4.945vw;
      background: #9bc765;
    }
  }
  .underInfo {
    font-size: 18px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
    margin-top: 50px;
    line-height: 30px;
    color:#717171;
  }
  .secondTitle {
    font-size: 24px;
    font-weight: 400;
    color: #5c85b1;
    margin-bottom: 20px;
  }
  .second_underInfo {
    width: 50%;
    min-height: 90px;
    li {
      line-height: 30px;
      color: #717171;
      list-style: inside;
    }
  }
  .float-left {
    float: left;
  }
  .float-right {
    float: right;
  }
  .green {
    color: #9bc765;
  }
  .listUl {
    width: 80%;
    text-align: center;
    overflow: hidden;
    margin-left: 10%;
    margin-top: 35px;
    li {
      float: left;
      position: relative;
      width: 30%;
      background: #fff;
      margin-right: 5%;
      height: 305px;
      padding: 20px 15px;
      box-sizing: border-box;
      border: 1px solid #ddd;
      overflow: hidden;
      &:last-child{
         margin-right:0;
       }
      p {
        color: #717171;
        margin-top: 0;
        margin-bottom: 10px;
      }
      .icon {
        height: 124px;
        margin-bottom: 30px;
      }
      .center-title {
        position: absolute;
        top: 50%;
        margin-top: -20px;
        left: 50%;
        margin-left: -75px;
        display: inline-block;
        width: 150px;
        text-align: center;
      }
      .backgroungImg {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        min-width: 100%;
      }
    }
  }

  #app {
    font-family:Helvetica, Microsoft Yahei, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// App.vue?2d492ade